var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgOss(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1429,
    height: 1430,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 751,
    width: 1429,
    height: 1430
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 808,
    y: 1089,
    width: 753,
    height: 754
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 808,
    y: 1089,
    width: 753,
    height: 754
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 808,
    y: 1089,
    width: 753,
    height: 754
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)",
    transform: "translate(-470 -751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.74 163.74 1265.26 163.74 1265.26 1265.26 163.74 1265.26Z",
    transform: "matrix(1 0 0 1.0007 470 751)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M86.2812 86.2812 666.719 86.2812 666.719 666.719 86.2812 666.719Z",
    fill: "#838282",
    transform: "matrix(1 0 0 1 808 1089)"
  })))))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOss);
export default __webpack_public_path__ + "static/media/OSS.b83584a39e2a41549d1cb5ff4dd47c6b.svg";
export { ForwardRef as ReactComponent };